import { Input, Spinner } from '@platform/components';

type OtherUpdateContentProps = {
  additionalDetails: string;
  setAdditionalDetails: (details: string) => void;
  isSaving: boolean;
  children?: React.ReactNode;
};

export const OtherUpdateContent = (props: OtherUpdateContentProps) => {
  const { additionalDetails, setAdditionalDetails, isSaving } = { ...props };

  return (
    <div className='flex flex-col gap-4 md:mt-8 md:w-[500px]'>
      {isSaving ?
        <div className='flex justify-center'>
          <Spinner />
        </div>
      : <>
          {props.children ?
            props.children
          : <div className='text-center text-xl'>
              Let us know what's going on, and a real person from our team will follow up with you.
            </div>
          }
          <div className='mt-4 items-stretch'>
            {/* TODO: Enforce max width of 700 */}
            <Input
              type='multiline'
              placeholder="Let us know what's going on..."
              required={true}
              characterCount={500}
              onChange={(e) => {
                setAdditionalDetails(e.target.value);
              }}
              value={additionalDetails}
              validate={(value: string) => {
                if (!value?.length) {
                  return "Let us know what's going on to continue";
                }
              }}
            />
          </div>
        </>
      }
    </div>
  );
};
